import React from 'react';

export function RecordingIcon(): React.ReactElement<
  React.SVGProps<SVGSVGElement>
> {
  return (
    <svg
      height="176"
      viewBox="0 0 176 176"
      width="176"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="recordButtonWithMic"
    >
      <title id="recordButtonWithMic">
        Visual representation of a button with a microphone icon contained
        inside
      </title>
      <filter id="a" height="174.6%" width="174.6%" x="-37.3%" y="-37.3%">
        <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="12.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          type="matrix"
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <g
        fill="none"
        fillRule="evenodd"
        filter="url(#a)"
        transform="translate(23 23)"
      >
        <circle cx="65" cy="65" fill="#fd6767" opacity=".25" r="65" />
        <circle cx="65" cy="65" fill="#fd6767" r="46.041667" />
        <path
          d="m75.6277828 56.2229938c.7262525 0 1.3155232.5975471 1.3155232 1.3351285v8.0107708c0 6.1741477-4.6130481 11.2735195-10.5241854 11.9398199v7.3904745h4.4372134c.7267506 0 1.3155231.5975471 1.3155231 1.3351285s-.5887725 1.3351284-1.3155231 1.3351284h-11.5049749c-.7267506 0-1.3160213-.597547-1.3160213-1.3351284s.5887725-1.3351285 1.3155231-1.3351285h4.4372134v-7.3904745c-5.9116354-.6663004-10.5241854-5.7656722-10.5241854-11.9398199v-8.0107708c0-.7375814.5887726-1.3351285 1.3155232-1.3351285s1.3155231.5975471 1.3155231 1.3351285v8.0107708c0 5.1534645 4.1308723 9.3458993 9.2086622 9.3458993 5.07779 0 9.2086623-4.1929403 9.2086623-9.3458993v-8.0107708c0-.7375814.5887725-1.3351285 1.3155231-1.3351285zm-10.8357566-13.7924382c3.9515766 0 7.1661394 3.3261515 7.1661394 7.4149013v15.8897189c0 4.0887498-3.2145628 7.4149014-7.1661394 7.4149014-3.9515767 0-7.1661394-3.3261516-7.1661394-7.4154028v-15.8892175c0-4.0887498 3.2145627-7.4149013 7.1661394-7.4149013z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export function ImportAudioIcon(): React.ReactElement<
  React.SVGProps<SVGSVGElement>
> {
  return (
    <svg
      height="176"
      viewBox="0 0 168 176"
      width="168"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="audioVideoFolderUpload"
    >
      <title id="audioVideoFolderUpload">
        Folder containing audio and video icons representing the types of files
        you can import into Anchor to create a podcast episode
      </title>
      <filter id="a" height="174%" width="180.2%" x="-40.1%" y="-37%">
        <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="12.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          type="matrix"
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <g
        fill="none"
        fillRule="evenodd"
        filter="url(#a)"
        transform="translate(24.666667 21)"
      >
        <g transform="translate(0 37.874016)">
          <path
            d="m107.342565 11.515748h-50.750889l-17.0959505-11.515748h-28.3905961c-6.1079528 0-11.1051294 4.86220472-11.1051294 10.8043307v70.5147638c0 5.9434055 4.9971766 10.8068898 11.1051294 10.8068898h96.2387516c6.106636 0 11.103813-4.8634843 11.103813-10.8056103v-59.5684055c0-5.942126-4.997177-10.2362205-11.105129-10.2362205z"
            fill="#8940fa"
            fillRule="nonzero"
          />
          <g transform="translate(22 39)">
            <path
              d="m75 7v17c0 1.1045695-.8954305 2-2 2h-24c-1.1045695 0-2-.8954305-2-2v-17zm-2-7c1.1045695 0 2 .8954305 2 2v3h-6.8571429l3.8571429-5zm-16 0h5.8571429l-3.8571429 5h-5.8571429zm12.8571429 0-3.8571429 5h-4.8571429l3.8571429-5zm-18.8571429 5h-4v-3c0-1.1045695.8954305-2 2-2h5.8571429z"
              fill="#fff"
            />
            <path
              d="m8.46855548 8.2714617h-7.31480315c-.63706514 0-1.15380816.51674302-1.15380816 1.15380816v6.34664284c0 .6370651.51674302 1.1538081 1.15380816 1.1538081h7.31480315c.30596993 0 .59937723.121718.81573371.3380745l7.52138871 7.5211095c.7269577.7269578 1.969821.2121689 1.969821-.8160129v-8.1969792-6.34664284-8.19697924c0-1.02818181-1.2428633-1.54297065-1.969821-.81601288l-7.52138871 7.52110952c-.21635648.21635648-.50976378.33807444-.81573371.33807444"
              fill="#fff"
            />
            <g stroke="#fff" strokeLinecap="round" strokeWidth="2">
              <path d="m22.3335719 3.35003579c4.9338113 0 8.9334288 4.12466763 8.9334288 9.21245981 0 5.0880694-3.9996175 9.212737-8.9334288 9.212737" />
              <path d="m22.3335719 7.25841088c2.7752608 0 5.0250537 2.37506323 5.0250537 5.30422332 0 2.929442-2.2497929 5.3042234-5.0250537 5.3042234" />
            </g>
          </g>
        </g>
        <g fill="#fff" transform="translate(91.102362)">
          <path
            d="m14.0470716 7.85309109-5.95582917-6.89940509c-.48286351-.55934409-1.36965106-.55934409-1.85200197 0l-5.9558292 6.89940509c-.65714546.76152264-.09841804 1.92044784.92625728 1.92044784h3.92339415c-.00717631.05861688-.01845338.116737-.01845338.17734089v17.79866688c0 .7982824.66790993 1.4460486 1.49216101 1.4460486h1.11745483c.82373849 0 1.49164842-.6477662 1.49164842-1.4460486v-17.79866688c0-.06060389-.01076447-.11872401-.01845338-.17734089h3.92339411c1.0246754 0 1.5839154-1.1589252.9262573-1.92044784"
            transform="translate(0 .489444)"
          />
          <path
            d="m.28373081 21.3425042 5.95578944 6.8994051c.48234769.559344 1.36912932.559344 1.8519896 0l5.95578945-6.8994051c.6571411-.7615227.0984174-1.9204479-.9262511-1.9204479h-3.92336797c.00717627-.0586169.01794067-.1172337.01794067-.1778376v-17.79866691c0-.79828238-.66739288-1.44555179-1.49163846-1.44555179h-1.11744737c-.82373299 0-1.49163846.64726941-1.49163846 1.44555179v17.79866691c0 .0606039.0107644.1192207.01845326.1778376h-3.92336796c-1.02518108 0-1.58390476 1.1589252-.9262511 1.9204479"
            transform="translate(13.032084 13.567362)"
          />
        </g>
      </g>
    </svg>
  );
}

export function SoundEffectsIcon(): React.ReactElement<
  React.SVGProps<SVGSVGElement>
> {
  return (
    <svg
      height="177"
      viewBox="0 0 186 177"
      width="186"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="snareDrumBeingPlayed"
    >
      <title id="snareDrumBeingPlayed">
        Snare drum that is being played with musical notes around it
      </title>
      <filter id="a" height="174.6%" width="168.3%" x="-34.2%" y="-37.3%">
        <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="12.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          type="matrix"
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <mask id="b" fill="#fff">
        <path
          d="m0 .09503459h12.5889124v13.57584861h-12.5889124z"
          fill="#fff"
          fillRule="evenodd"
        />
      </mask>
      <g
        fill="none"
        fillRule="evenodd"
        filter="url(#a)"
        transform="translate(22 23)"
      >
        <g fill="#fff">
          <path
            d="m132.450729 1.85643662v.83993606 1.17481551 5.491293c-.358604-.12729069-.75827-.18158313-1.176641-.13960914-1.162953.11679719-2.079537.98137015-2.153448 2.02798245-.089423 1.2701695 1.033837 2.3254504 2.431754 2.3254504 1.340886 0 2.42856-.9699642 2.436773-2.1698728v-7.84411773l6.166983-1.23732026v4.84982092c-.358148-.1250095-.757357-.17793322-1.174816-.13504676-1.151547.11907839-2.060832.97133291-2.143867 2.00836423-.107216 1.3431677 1.142422 2.4518286 2.64573 2.3364001 1.224546-.0939853 2.221428-1.1168732 2.221428-2.21869043v-7.1510906-1.51608231-.49866926z"
            fillOpacity=".5"
          />
          <path
            d="m3.33501608 1.95147121v.83993606 1.17435927 5.49174924c-.35860388-.12729069-.75826927-.18158313-1.1770967-.13960914-1.16249706.11679719-2.07908128.98137016-2.152992 2.02752626-.08942285 1.2706257 1.03383765 2.3254503 2.43175405 2.3254503 1.34088651 0 2.42856037-.9695079 2.43631643-2.1694166h.00045624v-7.84457388l6.166983-1.23686402v4.84982092c-.3581476-.12546573-.7573568-.17793322-1.1748155-.13504675-1.15200356.11907838-2.06083172.9713329-2.14386722 2.00836422-.10721617 1.34316771 1.14242254 2.45182851 2.64573012 2.33594381 1.2245456-.0939852 2.2214279-1.1164169 2.2214279-2.21823414v-7.15154684-1.51562607-.49866926z"
            mask="url(#b)"
            transform="translate(0 18.514636)"
          />
          <path d="m117.216567 28.2342157.233595 1.1182418.326667 1.5644437 1.526119 7.3125992c-.512812-.0698046-1.059843-.0314805-1.605505.1414341-1.516082.479051-2.496084 1.8847234-2.303551 3.2986082.234051 1.7163712 2.022508 2.80952 3.884876 2.4212605 1.785263-.3727472 2.963728-1.9673027 2.641167-3.5668767h.000457l-2.180367-10.4460489 7.867386-3.3615692 1.348187 6.4585198c-.511444-.0675234-1.057106-.0269181-1.600943.1459964-1.501027.479051-2.474641 1.8669302-2.296707 3.2703214.229944 1.8190251 2.202722 2.9473042 4.171849 2.3756367 1.605049-.4653638 2.648468-2.1046307 2.342331-3.5718954l-1.988289-9.5230773-.421109-2.0184015-.138697-.6642841z" />
          <path
            d="m22.120567 36.2330896-.4530454 1.0488936-.6341722 1.4668085-2.9632725 6.8572726c-.3786784-.3526727-.8481484-.6359972-1.3942665-.8089118-1.5151698-.4817884-3.1256936.10311-3.7831341 1.3696296-.7970496 1.538438.0360429 3.462398 1.7820697 4.2170174 1.6743972.7235951 3.555927.0980914 4.2133675-1.395179h.0004562l4.2329857-9.795452 8.3678801 1.7829821-2.616987 6.0565732c-.3791347-.3503916-.8490609-.6314348-1.3933541-.8029807-1.5028513-.4726637-3.0983192.101285-3.7607783 1.3509238-.8590981 1.6196485.1035663 3.678199 2.0425821 4.3452205 1.5799558.5433807 3.3770814-.1957265 3.9715608-1.5717435l3.859326-8.9299665.8175804-1.8929358.269181-.6227663z"
            fillOpacity=".5"
          />
        </g>
        <path
          d="m126.130068 78.707483c0 10.1289166-21.504106 18.3404417-48.0310204 18.3404417-26.5264647 0-48.0310204-8.2115251-48.0310204-18.3404417v31.498346h.046287c-.0283115.25714-.046287.515173-.046287.774546 0 10.128916 21.5045557 18.340441 48.0310204 18.340441 26.5269144 0 48.0310204-8.211525 48.0310204-18.340441 0-.259373-.017526-.517406-.045838-.774546h.045838z"
          fill="#006f7f"
        />
        <path
          d="m125.840534 78.8273914c0 9.9830995-21.504106 18.0764104-48.03102 18.0764104-26.5264647 0-48.0310205-8.0933109-48.0310205-18.0764104 0-9.9826596 21.5045558-18.0759705 48.0310205-18.0759705 26.526914 0 48.03102 8.0933109 48.03102 18.0759705"
          fill="#00b3ce"
        />
        <path
          d="m56.0198956 15.9069148c-.6149504.2666729-1.1945201.5788077-1.7409554.9275337l-20.8611389-15.99039231c-1.7740898-1.35997616-4.3293631-1.04285168-5.7069643.70854037-1.3776012 1.75194646-1.0558052 4.27397318.7182845 5.63394934l20.8617005 15.9903923c-.9474167 2.7776114-.8890104 5.8984046.3998582 8.7918883 2.7456552 6.1606421 10.0301497 8.9576579 16.2700709 6.247685 6.2404829-2.7099728 9.0737474-9.9012695 6.3292154-16.0613572-2.7456552-6.1611965-10.0295881-8.9582123-16.2700709-6.2482395"
          fill="#00b3ce"
        />
        <path
          d="m113.932881.69702377c-1.828946-1.251509-4.317085-.77195882-5.558668 1.07160806l-14.5950944 21.67221477c-2.8213277-.7591486-5.9211414-.501829-8.7187094.9602143-5.9548471 3.1117849-8.2799836 10.4999766-5.1928786 16.5024299 3.0871049 6.0030102 10.4172526 8.3467351 16.3720997 5.2349502 5.9553997-3.111785 8.2799837-10.5010906 5.1934307-16.5035439-.304455-.590387-.650905-1.1451279-1.031613-1.663109l14.595094-21.67165774c1.241031-1.84356688.765284-4.35215456-1.063661-5.60310659"
          fill="#00b3ce"
        />
      </g>
    </svg>
  );
}

export function EpisodeBuilderIcon(): React.ReactElement<
  React.SVGProps<SVGSVGElement>
> {
  return (
    <svg
      height="180"
      viewBox="0 0 194 180"
      width="194"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="episodeAudioSegmentOrdering"
    >
      <title id="episodeAudioSegmentOrdering">
        User interface showing the ability to rearrange audio segments ordering
        inside an episode
      </title>
      <defs>
        <filter id="a" height="174.6%" width="175.5%" x="-41.6%" y="-37.3%">
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="12.5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            type="matrix"
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <path
          id="b"
          d="m2 0h99.673865c1.104569 0 2 .8954305 2 2v17.2831173c0 1.1045695-.895431 2-2 2h-99.673865c-1.1045695 0-2-.8954305-2-2v-17.2831173c0-1.1045695.8954305-2 2-2z"
        />
        <mask
          id="c"
          fill="#fff"
          height="21.283117"
          width="103.673865"
          x="0"
          y="0"
        >
          <use href="#b" />
        </mask>
        <mask
          id="d"
          fill="#fff"
          height="21.283117"
          width="103.673865"
          x="0"
          y="0"
        >
          <use href="#b" />
        </mask>
        <path
          id="e"
          d="m2 0h99.673865c1.104569 0 2 .8954305 2 2v17.2831173c0 1.1045695-.895431 2-2 2h-99.673865c-1.1045695 0-2-.8954305-2-2v-17.2831173c0-1.1045695.8954305-2 2-2z"
        />
        <path
          id="f"
          d="m2 0h99.673865c1.104569 0 2 .8954305 2 2v17.2831173c0 1.1045695-.895431 2-2 2h-99.673865c-1.1045695 0-2-.8954305-2-2v-17.2831173c0-1.1045695.8954305-2 2-2z"
        />
        <path
          id="g"
          d="m2 0h99.673865c1.104569 0 2 .8954305 2 2v17.2831173c0 1.1045695-.895431 2-2 2h-99.673865c-1.1045695 0-2-.8954305-2-2v-17.2831173c0-1.1045695.8954305-2 2-2z"
        />
        <path
          id="h"
          d="m2 0h99.84216c1.104569 0 2 .8954305 2 2v17.2831173c0 1.1045695-.895431 2-2 2h-99.84216c-1.1045695 0-2-.8954305-2-2v-17.2831173c0-1.1045695.8954305-2 2-2z"
        />
        <filter id="i" height="255.1%" width="131.8%" x="-15.9%" y="-77.5%">
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="5.5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            type="matrix"
            values="0 0 0 0 0.160784314   0 0 0 0 0.184313725   0 0 0 0 0.211764706  0 0 0 0.245738636 0"
          />
        </filter>
        <mask id="j" fill="#fff">
          <use fill="#fff" fillRule="evenodd" href="#e" />
        </mask>
        <mask id="k" fill="#fff">
          <use fill="#fff" fillRule="evenodd" href="#f" />
        </mask>
        <mask id="l" fill="#fff">
          <use fill="#fff" fillRule="evenodd" href="#g" />
        </mask>
        <mask id="m" fill="#fff">
          <use fill="#fff" fillRule="evenodd" href="#h" />
        </mask>
      </defs>
      <g
        fill="none"
        fillRule="evenodd"
        filter="url(#a)"
        transform="translate(26.333333 25)"
      >
        <rect
          fill="#292f36"
          height="129.75"
          rx="5"
          stroke="#85888d"
          strokeWidth=".25"
          width="121.75"
          x="21.125"
          y=".125"
        />
        <g transform="translate(29 7)">
          <rect fill="#8840f9" height="12" rx="2.5" width="103.671111" />
          <g fill="#fff" transform="translate(3.555556 3.692308)">
            <path
              d="m1.70192308.00961538.57417582.00274726.02197802 4.59340659-.57417582-.00274725z"
              transform="matrix(.70710678 .70710678 -.70710678 .70710678 2.217571 -.738306)"
            />
            <path
              d="m1.70192308.00961538.57417582.00274726.02197802 4.59340659-.57417582-.00274725z"
              transform="matrix(-.70710678 .70710678 .70710678 .70710678 1.782429 -.738306)"
            />
          </g>
          <g fill="#6a2dca">
            <path d="m14.5 4h50.0363448c1.3807118 0 2.5 1.11928813 2.5 2.5s-1.1192882 2.5-2.5 2.5h-50.0363448c-1.3807119 0-2.5-1.11928813-2.5-2.5s1.1192881-2.5 2.5-2.5z" />
            <path d="m88.5363448 4h8c1.3807118 0 2.5 1.11928813 2.5 2.5s-1.1192882 2.5-2.5 2.5h-8c-1.3807119 0-2.5-1.11928813-2.5-2.5s1.1192881-2.5 2.5-2.5z" />
          </g>
        </g>
        <g
          mask="url(#c)"
          stroke="#85888d"
          strokeDasharray="2 2 2 2"
          strokeLinejoin="round"
          transform="translate(29 51)"
        >
          <use mask="url(#d)" href="#b" />
        </g>
        <g transform="translate(29 76)">
          <use fill="#fff" href="#e" />
          <g fill="#cccdcf" mask="url(#j)">
            <path
              d="m0 4.224h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 90.666667 17.424)"
            />
            <path
              d="m0 2.112h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 90.666667 13.2)"
            />
            <path
              d="m0 0h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 90.666667 8.976)"
            />
          </g>
          <path
            d="m27.5141148 7.92h49.8009692c1.4457091 0 2.6176878 1.17197874 2.6176878 2.6176878 0 1.445709-1.1719787 2.6176878-2.6176878 2.6176878h-49.8009692c-1.445709 0-2.6176877-1.1719788-2.6176877-2.6176878 0-1.44570906 1.1719787-2.6176878 2.6176877-2.6176878z"
            fill="#cccdcf"
            mask="url(#j)"
          />
          <ellipse
            cx="13.777778"
            cy="10.12"
            fill="#feabe6"
            rx="6.666667"
            ry="6.6"
          />
          <path
            d="m12.4444444 8.30809018v4.04258402c0 .1932996.1567004.35.35.35.0674691 0 .1335001-.0195007.1901443-.0561546l3.1236672-2.021292c.1622864-.1050138.208715-.3217034.1037012-.4839897-.0268559-.0415025-.0621987-.0768453-.1037012-.1037012l-3.1236672-2.02129198c-.1622863-.10501378-.3789759-.05858519-.4839897.10370117-.0366539.05664419-.0561546.12267526-.0561546.19014429z"
            fill="#fff"
          />
        </g>
        <g transform="translate(29 27)">
          <use fill="#fff" href="#f" />
          <g fill="#cccdcf" mask="url(#k)">
            <path
              d="m0 4.224h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 89.777778 17.424)"
            />
            <path
              d="m0 2.112h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 89.777778 13.2)"
            />
            <path
              d="m0 0h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 89.777778 8.976)"
            />
          </g>
          <path
            d="m26.6475382 7.92h49.7563447c1.4580318 0 2.64 1.18196826 2.64 2.64 0 1.4580317-1.1819682 2.64-2.64 2.64h-49.7563447c-1.4580318 0-2.64-1.1819683-2.64-2.64 0-1.45803174 1.1819682-2.64 2.64-2.64z"
            fill="#cccdcf"
            mask="url(#k)"
          />
          <ellipse
            cx="13.777778"
            cy="10.12"
            fill="#fd6767"
            rx="6.666667"
            ry="6.6"
          />
          <path
            d="m12.4444444 8.30809018v4.04258402c0 .1932996.1567004.35.35.35.0674691 0 .1335001-.0195007.1901443-.0561546l3.1236672-2.021292c.1622864-.1050138.208715-.3217034.1037012-.4839897-.0268559-.0415025-.0621987-.0768453-.1037012-.1037012l-3.1236672-2.02129198c-.1622863-.10501378-.3789759-.05858519-.4839897.10370117-.0366539.05664419-.0561546.12267526-.0561546.19014429z"
            fill="#fff"
          />
        </g>
        <g transform="translate(29 101)">
          <use fill="#fff" href="#g" />
          <g fill="#cccdcf" mask="url(#l)">
            <path
              d="m0 4.224h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 90.666667 17.424)"
            />
            <path
              d="m0 2.112h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 90.666667 13.2)"
            />
            <path
              d="m0 0h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 90.666667 8.976)"
            />
          </g>
          <path
            d="m27.5141148 7.92h49.8009692c1.4457091 0 2.6176878 1.17197874 2.6176878 2.6176878 0 1.445709-1.1719787 2.6176878-2.6176878 2.6176878h-49.8009692c-1.445709 0-2.6176877-1.1719788-2.6176877-2.6176878 0-1.44570906 1.1719787-2.6176878 2.6176877-2.6176878z"
            fill="#cccdcf"
            mask="url(#l)"
          />
          <ellipse
            cx="13.777778"
            cy="10.12"
            fill="#1cee4e"
            rx="6.666667"
            ry="6.6"
          />
          <path
            d="m16.3032401 13.1749985c-.3827382.4090136-.8801544.683929-1.4621458.8241863-.2534386.0610301-.3666832.1780511-.3552154.4095735.0111811.2273231-.0017202.4554861-.0022935.6833691-.0005734.2032471-.1181185.3118694-.3460412.3166287-.2780944.0064389-.5573356.006159-.83629.0016797-.2442644-.0036394-.3592292-.1254197-.3615227-.3353856-.0022936-.166573-.0034404-.332866-.0054473-.499159-.0043004-.3667405-.0174884-.382418-.4191484-.4384089-.5137579-.0713884-1.0177681-.1746916-1.4879483-.3748592-.3695502-.1578943-.407394-.2388012-.3016034-.5795059.0788412-.2536389.1582557-.5069978.2477047-.7578371.1037836-.2911527.1929459-.3278268.4979896-.1884094.5194918.2385213 1.0728136.3720596 1.6505045.4353294.3732772.0414332.7376669.0075587 1.0834214-.1248598.6444909-.2477598.7454076-.905653.2009733-1.2995491-.1854918-.1340983-.3956394-.2329222-.6163947-.3183084-.564503-.2183646-1.1548085-.3852175-1.6883484-.6662919-.8661063-.45604599-1.4154144-1.08202443-1.3511947-2.00895404.0728206-1.04814994.7462678-1.70184387 1.8388634-2.05094723.4503982-.14417661.4529785-.13857752.455272-.55291029.0008601-.13997729-.0022935-.28023454.0020069-.42049178.0091742-.31242931.0696669-.36590063.4220154-.37485918.1095176-.00279955.2190352-.00027996.3288394-.00027996.7534351-.00104125.7534351-.00104125.7563021.66237254.0022936.46808405.0017202.47004373.5329665.54339183.4062471.05599092.7941458.16125384 1.17029.30711017.2072806.08062692.2852617.2077263.2216154.39977514-.0943227.28583363-.1823382.57362693-.2864086.85694096-.0983364.26819649-.1958128.30711018-.488242.18253039-.5882986-.25027939-1.2049801-.3544225-1.8552049-.32334754-.170297.00811868-.3365802.02827541-.4942626.0887456-.5613493.21612494-.6525184.76035664-.1745974 1.09686204.2416841.17049234.5180583.29367235.8050402.39809541.4968429.18113061.9976995.35470245 1.4693132.5842652 1.5028565.73152134 1.9085302 2.39221184.8491913 3.52350834"
            fill="#fff"
          />
        </g>
        <g transform="translate(0 57)">
          <use fill="#000" filter="url(#i)" href="#h" />
          <use fill="#fff" fillRule="evenodd" href="#h" />
          <g fill="#cccdcf" mask="url(#m)">
            <path
              d="m0 4.224h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 89.777778 17.424)"
            />
            <path
              d="m0 2.112h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 89.777778 13.2)"
            />
            <path
              d="m0 0h7.11111111v1.056h-7.11111111z"
              transform="matrix(1 0 0 -1 89.777778 8.976)"
            />
          </g>
          <ellipse
            cx="13.777778"
            cy="10.12"
            fill="#fd6767"
            rx="6.666667"
            ry="6.6"
          />
          <path
            d="m12.4444444 8.30809018v4.04258402c0 .1932996.1567004.35.35.35.0674691 0 .1335001-.0195007.1901443-.0561546l3.1236672-2.021292c.1622864-.1050138.208715-.3217034.1037012-.4839897-.0268559-.0415025-.0621987-.0768453-.1037012-.1037012l-3.1236672-2.02129198c-.1622863-.10501378-.3789759-.05858519-.4839897.10370117-.0366539.05664419-.0561546.12267526-.0561546.19014429z"
            fill="#fff"
          />
        </g>
        <path
          d="m26.5 64h50c1.3807119 0 2.5 1.1192881 2.5 2.5s-1.1192881 2.5-2.5 2.5h-50c-1.3807119 0-2.5-1.1192881-2.5-2.5s1.1192881-2.5 2.5-2.5z"
          fill="#cccdcf"
        />
      </g>
    </svg>
  );
}

export function TranscribedVideoSquareIcon({
  isActive,
}: {
  isActive: boolean;
}): React.ReactElement<React.SVGProps<SVGSVGElement>> {
  return (
    <svg
      height="44"
      viewBox="0 0 43 44"
      width="43"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="TranscribedVideoSquareIcon"
    >
      <title title="TranscribedVideoSquareIcon">
        Square icon with dotted outline representing a video that has a square
        aspect ratio
      </title>
      <g fill="none" fillRule="evenodd">
        <path
          d="m40.6537817 44h-38.30756345c-1.29545384 0-2.34621825-1.0623946-2.34621825-2.3736931v-39.25261381c0-1.31129849 1.05076441-2.37369309 2.34621825-2.37369309h38.30756345c1.2954539 0 2.3462183 1.0623946 2.3462183 2.37369309v39.25261381c0 1.3112985-1.0507644 2.3736931-2.3462183 2.3736931"
          fill={isActive ? '#8940fa' : '#e8e8ea'}
        />
        <path
          d="m39.7629082 43h-36.52581638c-1.23456445 0-2.23709182-1.0147323-2.23709182-2.2657632v-37.46847359c0-1.25103095 1.00252737-2.26576321 2.23709182-2.26576321h36.52581638c1.2352002 0 2.2370918 1.01473226 2.2370918 2.26576321v37.46847359c0 1.2510309-1.0018916 2.2657632-2.2370918 2.2657632z"
          stroke={isActive ? '#fff' : '#a7a9ac'}
          strokeDasharray="3.016 3.016"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export function TranscribedVideoStoriesIcon({
  isActive,
}: {
  isActive: boolean;
}): React.ReactElement<React.SVGProps<SVGSVGElement>> {
  return (
    <svg
      height="59"
      viewBox="0 0 37 59"
      width="37"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="TranscribedVideoStoriesIcon"
    >
      <title title="TranscribedVideoStoriesIcon">
        Rectangle icon that is taller vertically with dotted outline
        representing a video that has a tall aspect ratio
      </title>
      <g fill="none" fillRule="evenodd">
        <path
          d="m0 57.39285v-55.78569996c0-.88758963.73476989-1.60715004 1.64029143-1.60715004h33.72008937c.9048493 0 1.6396192.71956041 1.6396192 1.60715004v55.78569996c0 .8875896-.7347699 1.60715-1.6396192 1.60715h-33.72008937c-.90552154 0-1.64029143-.7195604-1.64029143-1.60715"
          fill={isActive ? '#8940fa' : '#e8e8ea'}
        />
        <path
          d="m1 56.447347v-53.89405737c0-.85749227.6950526-1.55328963 1.55099112-1.55328963h31.89801778c.8565744 0 1.5509911.69579736 1.5509911 1.55328963v53.89405737c0 .8574922-.6944167 1.552653-1.5509911 1.552653h-31.89801778c-.85593852 0-1.55099112-.6951608-1.55099112-1.552653z"
          stroke={isActive ? '#fff' : '#a7a9ac'}
          strokeDasharray="3.031 3.031"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export function TranscribedVideoWideIcon({
  isActive,
}: {
  isActive: boolean;
}): React.ReactElement<React.SVGProps<SVGSVGElement>> {
  return (
    <svg
      height="38"
      viewBox="0 0 84 38"
      width="84"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="TranscribedVideoWideIcon"
    >
      <title id="TranscribedVideoWideIcon">
        Rectangle icon that is wider horizontally with dotted outline
        representing a video that has a wide aspect ratio
      </title>
      <g fill="none" fillRule="evenodd">
        <path
          d="m79.8305121 38h-76.62249725c-1.77159987 0-3.20801485-1.431123-3.20801485-3.1968358v-30.5928936c0-1.77338982 1.44283614-3.2102706 3.22214142-3.2102706h76.59681258c1.7568312 0 3.181046 1.418328 3.181046 3.16804703v30.67414197c0 1.7439613-1.4190778 3.157811-3.1694879 3.157811"
          fill="#e8e8ea"
        />
        <path
          d="m81.6443028 37h-78.28860559c-1.30147215 0-2.35569721-1.0713787-2.35569721-2.3932095v-32.21358097c0-1.32183084 1.05422506-2.39320953 2.35569721-2.39320953h78.28860559c1.3008198 0 2.3556972 1.07137869 2.3556972 2.39320953v32.21358097c0 1.3218308-1.0548774 2.3932095-2.3556972 2.3932095"
          fill={isActive ? '#8940fa' : '#e8e8ea'}
        />
        <path
          d="m80.6726847 37h-77.34536939c-1.28514725 0-2.32731531-1.0424225-2.32731531-2.3285282v-31.3429436c0-1.28610569 1.04216806-2.3285282 2.32731531-2.3285282h77.34536939c1.2857917 0 2.3273153 1.04242251 2.3273153 2.3285282v31.3429436c0 1.2861057-1.0415236 2.3285282-2.3273153 2.3285282z"
          stroke={isActive ? '#fff' : '#a7a9ac'}
          strokeDasharray="2.999 2.999"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}
